
import { Options, Vue } from 'vue-class-component'

@Options({
  name: 'IconTrolley',
})
export default class IconTrolley extends Vue {}
